<app-page-meta pageTitle="finzy - Loan Application Summary"></app-page-meta>

<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <p class="heading">Quick Review</p>

            <div class="greydiv">
                <div class="row">
                    <div class="col-sm-12 col-md-7">
            <span class="loan mx-1">
              <span>Loan Amount: </span>
              <span>
                <app-indian-currency-formatter class="font-bold" [amount]=summary?.getLoanAmount()>
                </app-indian-currency-formatter>
              </span>
            </span>
                    </div>
                    <div class="col-sm-12 col-md-5">
          <span class="tenure">
              <span class="greytxthead">Tenure: </span>
              <span class="greyHeadTxt2 font-bold">{{summary?.getTenure()}}</span>
              <span style="font-size: 12px;"> months</span></span>
                    </div>
                </div>
                <div class="row bg-white">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-sm-5 summarydetails">
                                <p class="greytxt">Name</p>
                            </div>
                            <div class="col-sm-7 summarydetails1">
                                <p class="field-value">{{summary?.getUserName()}}</p>
                            </div>
                        </div>
                        <div class="row separator"></div>
                        <div class="row">
                            <div class="col-sm-5 summarydetails">
                                <p class="greytxt">{{summary?.getSalariedType()}}</p>
                            </div>
                            <div class="col-sm-7 summarydetails1">
                                <p class="field-value">
                                    <app-indian-currency-formatter
                                            [amount]=summary?.getIncome()></app-indian-currency-formatter>
                                </p>
                            </div>
                        </div>
                        <div class="separator"></div>
                        <div class="row">
                            <div class="col-sm-5 summarydetails">
                                <p class="greytxt">Existing emi</p>
                            </div>
                            <div class="col-sm-7 summarydetails1">
                                <p class="field-value" *ngIf="summary?.getExistingEmi() == 'None'">None</p>
                                <p class="field-value" *ngIf="summary?.getExistingEmi() != 'None'">
                                    <app-indian-currency-formatter
                                            [amount]=summary?.getExistingEmi()></app-indian-currency-formatter>
                                </p>
                            </div>
                        </div>
                        <div class="separator"></div>
                        <div class="row">
                            <div class="col-sm-5 summarydetails">
                                <p class="greytxt">Address</p>
                            </div>
                            <div class="col-sm-7 summarydetails1">
                                <p class="field-value">{{summary?.getAddress()}}</p>
                            </div>
                        </div>
                        <div class="separator"></div>
                        <div class="row">
                            <div class="col-sm-5 summarydetails">
                                <p class="greytxt">Bank Name</p>
                            </div>
                            <div class="col-sm-7 summarydetails1">
                                <p class="field-value">{{summary?.getBankName()}}</p>
                            </div>
                        </div>
                        <div class="separator"></div>
                        <div class="row">
                            <div class="col-sm-5 summarydetails">
                                <p class="greytxt">Account Number</p>
                            </div>
                            <div class="col-sm-7 summarydetails1">
                                <p class="field-value">{{summary?.getFormattedAccountNo()}}</p>
                            </div>
                        </div>
                        <div class="separator"></div>
                        <div class="row">
                            <div class="col-sm-5 summarydetails">
                                <p class="greytxt">IFSC</p>
                            </div>
                            <div class="col-sm-7 summarydetails1">
                                <p class="field-value">{{summary?.getBankIfsc()}}</p>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="ptxt1">
                    Our team will reach out to you on your registered email id and phone while processing your loan
                    application.
                </div>
            </div>
            <div class="row" style="margin-top: 20px;">
                <div class="col-xs-6">
                    <button mat-stroked-button class="button-back primary" type="button" (click)="previousPage()">
                        <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
                    </button>
                </div>
                <div class="col-xs-6">
                    <div class="pull-right">
                        <app-forward-button class="button-forward" [isLoading]="shouldShowLoader" (click)="submitApplication()">
                            Submit
                        </app-forward-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
